export enum ImageState {
  Loading = 'loading',
  OK = 'ok',
  ImageError = 'error'
}
